<template>
    <div class="row">
        <go-lotus-side-menu
            :side-menu-items="menuItems"
            @set-parent-prop="propSetFromChild($event)"
            :current-component="component"
        ></go-lotus-side-menu>

        <div class="col-12 col-md-10 main-content position-relative">
            <transition name="simple-fade" mode="out-in">
                <component
                    :is="component"
                    :organization="organization"
                    :user="user"
                    :subscription="subscription"
                    @set-parent-prop="propSetFromChild($event)"
                ></component>
            </transition>
        </div>
    </div>
</template>

<script>
import GoLotusSideMenu from "./GoLotusSideMenu";
import AdminMyAlerts from "./control-center/MyAlerts";
import AdminMyCenters from "./control-center/MyCenters";
import AdminPermissions from "./control-center/Permissions";
import AdminUserAccounts from "./control-center/UserAccounts";
import AdminCptFunding from "./control-center/CptFunding";
import AdminCalendar from "./control-center/Calendar";
import AdminOrganization from "./control-center/AdminOrganization";
import TrackerCustomizations from "./control-center/TrackerCustomizations";
import { sideMenuItems } from "../plugins/sideMenuItems";
import { helpers } from "../plugins/helpers";

export default {
    name: "ControlCenter",
    props: [
        "user",
        "organization",
        "organizationUsers",
        "organizationInvites",
        "subscription",
        "trackerTypes",
    ],
    provide: function() {
        return {
            trackerTypes: this.trackerTypes,
        };
    },
    components: {
        GoLotusSideMenu,
        AdminMyAlerts,
        AdminMyCenters,
        AdminPermissions,
        AdminUserAccounts,
        AdminCptFunding,
        AdminCalendar,
        AdminOrganization,
        TrackerCustomizations,
    },
    mixins: [sideMenuItems],
    data() {
        return {
            component: null,
            availableSubItems: [
                {
                    title: "Organization",
                    component: "admin-organization",
                    permission: "ccenter.organization.view",
                    tier: ["professional_platinum", "professional_gold"],
                },
                {
                    title: "Tracker Customizations",
                    component: "tracker-customizations",
                    permission: "ccenter.organization.view",
                    tier: ["professional_platinum", "professional_gold"],
                },
                {
                    title: "My Centers",
                    component: "admin-my-centers",
                    permission: "ccenter.centers.view",
                    tier: ["professional_platinum", "professional_gold"],
                },
                {
                    title: "Permissions",
                    component: "admin-permissions",
                    permission: "ccenter.permissions.view",
                    tier: ["professional_platinum", "professional_gold"],
                },
                {
                    title: "User Accounts",
                    component: "admin-user-accounts",
                    permission: "ccenter.accounts.view",
                    tier: ["professional_platinum", "professional_gold"],
                },
                {
                    title: "CPT/Funding",
                    component: "admin-cpt-funding",
                    permission: "ccenter.funding.view",
                    tier: ["professional_platinum"],
                },
                //{title: "Appointments", component: "admin-calendar", permission: "ccenter.appointments.view"},
            ],
        };
    },
    mounted() {
        const view = helpers.getRequestParam("view");
        switch (view) {
            case "stripe":
                this.component = "admin-organization";
        }
    },
    watch: {
        menuItems() {
            let menu = this.menuItems.find(m => m.title === "Control Center");
            if (menu) {
                menu.items = [];
                this.availableSubItems.forEach(s => {
                    if (this.$root.permissions.includes(s.permission)) {
                        if (s.tier.includes(this.$root.organizationType)) {
                            menu.items.push(s);
                        }
                    }
                });
            }
        },
        "$root.permissions"() {
            if (this.$root.permissions && this.$root.permissions.length) {
                if (this.$root.permissions.includes("ccenter.organization.view")) {
                    this.component = "admin-organization";
                } else {
                    // If permissions doesn't include My Centers, open the first one.
                    this.ccenterItems = this.menuItems.find(
                        item => item.title === "Control Center"
                    );
                    if (this.ccenterItems && this.ccenterItems.items) {
                        let targetItem = this.ccenterItems.items.find(
                            a => a.permission === this.$root.permissions[0]
                        );
                        if (targetItem) {
                            this.component = targetItem.component;
                        }
                    }
                }
            }
        },
    },
};
</script>

<style scoped lang="scss"></style>
